import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "coupeFilled"
const CoupeFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M6.75 15C7.786 15 8.625 15.84 8.625 16.875S7.785 18.75 6.75 18.75 4.875 17.91 4.875 16.875 5.715 15 6.75 15M17.625 15C18.661 15 19.5 15.84 19.5 16.875S18.66 18.75 17.625 18.75 15.75 17.91 15.75 16.875 16.59 15 17.625 15" />
          <path
            fillRule="evenodd"
            d="M12.01 9.188C12.303 9.188 12.587 9.285 12.817 9.464L15.85 11.823 21.214 12.139C21.961 12.184 22.438 12.93 22.205 13.61V14.064H21.375C21.065 14.063 20.813 14.314 20.813 14.625 20.813 14.935 21.065 15.188 21.375 15.188H22.205V16.125C22.205 16.85 21.617 17.437 20.893 17.438H20.188Q20.249 17.165 20.25 16.875C20.25 15.471 19.147 14.324 17.76 14.254L17.625 14.25C16.175 14.25 15 15.425 15 16.875Q15 16.965 15.007 17.053 15.02 17.25 15.062 17.437H9.314Q9.374 17.167 9.375 16.876C9.375 15.471 8.272 14.324 6.885 14.254L6.75 14.25C5.3 14.25 4.125 15.425 4.125 16.875Q4.125 16.965 4.132 17.053 4.145 17.25 4.187 17.437H3.357C2.858 17.438 2.403 17.158 2.181 16.713L1.78 15.905C1.623 15.593 1.598 15.233 1.707 14.903L1.737 14.813H2.626C2.935 14.813 3.188 14.56 3.188 14.25S2.936 13.688 2.625 13.688H1.955V12.375C1.955 11.65 2.543 11.063 3.268 11.063H4.647L8.512 9.305C8.682 9.228 8.868 9.188 9.055 9.188zM8.862 11.812H14.003L12.125 10.353C12.093 10.327 12.052 10.312 12.011 10.312H9.93z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default CoupeFilledIcon
